export default __webpack_public_path__ + "static/media/purple_pulumi.447816aa.svg";